import { Icon, IconButton, Menu, styled } from '../../../base';
import { TOP_HEADER_HEIGHT } from '../../../common';
import { shouldForwardProp } from '@mui/system';

export const HeaderContainer = styled('header')(({ theme }) => ({
    height: `${TOP_HEADER_HEIGHT}px`,
    width: '100%',
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    alignItems: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 0,
}));

export const LeftBackgroundSection = styled('div')(({ theme }) => ({
    width: '110px',
    height: '100%',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

export const StyledLogo = styled('img')(() => ({
    height: '44px',
}));

export const BreadcrumbsWrapper = styled('div')(({ theme }) => ({
    paddingInlineStart: theme.spacing(2),
}));

export const CompanyLogoWrapper = styled('div')(({}) => ({
    display: 'flex',
    marginInline: 'auto',
    position: 'absolute',
    right: 0,
    left: 0,
    width: 'fit-content',
}));

export const CompanyLogoImg = styled('img')(({ theme }) => ({
    width: '120px',
    height: '60px',
    objectFit: 'contain',

    // Apply styles for small screens
    [theme.breakpoints.down('sm')]: {
        width: '60px',
    },
}));

export const ButtonGroupWrapper = styled('div')(({}) => ({
    position: 'absolute',
    insetInlineEnd: '16px',
}));

const customShouldForwardProp = (prop: PropertyKey) =>
    shouldForwardProp(prop) &&
    !['borderColor', 'iconColor'].includes(prop as string);

export const StyledIconButton = styled(IconButton, {
    shouldForwardProp: customShouldForwardProp,
})<{ borderColor: string }>(({ theme, borderColor }) => ({
    border: '2px solid',
    borderColor: borderColor,
    marginInlineEnd: theme.spacing(1),
    height: '46px',
    width: '46px',

    '&:hover': {
        backgroundColor: theme.palette.background.mainBackground, // Background color on hover
        borderColor: borderColor,
    },
}));

export const StyledIcon = styled(Icon, {
    shouldForwardProp: customShouldForwardProp,
})<{ iconColor: string }>(({ theme, iconColor }) => ({
    color: iconColor || theme.palette.secondary.main,
}));

export const StyledMenu = styled(Menu)(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    padding: 0,
}));
